export const INHERIT_LABEL = 'Assign also to children';

export const INHERIT_TOOLTIP =
  "E.g. each device's interfaces will inherit this label. Removing it from the device will remove it from interfaces too.";
